import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  ShareFolderEntriesInput,
  ShareFolderEntriesMutation,
} from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const SHARE_FOLDER_ENTRIES_MUTATION = graphql(`
  mutation ShareFolderEntries($input: ShareFolderEntriesInput!) {
    shareFolderEntries(input: $input) {
      id
    }
  }
`);

const useShareFolderEntries = (
  options?: UseMutationOptions<
    ShareFolderEntriesMutation,
    unknown,
    ShareFolderEntriesInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(SHARE_FOLDER_ENTRIES_MUTATION, { input });
    },
    ...options,
  });
};

export default useShareFolderEntries;
